// extracted by mini-css-extract-plugin
export default {"button":"button_button__VWeAX","important":"button_important__aYEua","emphasized":"button_emphasized__J9KDO","large":"button_large__a+nfk"};